<template>
  <section>
    <h2>Действительно, страница не найдена!</h2>
    <p>
      Запрашиваемая страница не найдена. Может быть переместиться на
      <router-link to="/home">главную?</router-link>
    </p>
  </section>
</template>
